// src/pages/Private/Student/CourseView/CourseDetail.jsx
import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../../../../utils/axios';
import './CourseDetail.css';

function CourseDetail() {
  const { courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [modules, setModules] = useState([]);
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCourseData();
  }, [courseId]);

  const loadCourseData = async () => {
    try {
      const [courseRes, modulesRes, progressRes] = await Promise.all([
        axios.get(`/courses/${courseId}`),
        axios.get(`/modules/course/${courseId}`),
        axios.get(`/progress/course/${courseId}`)
      ]);
      setCourse(courseRes.data);
      setModules(modulesRes.data);
      setProgress(progressRes.data);
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const isLessonCompleted = (lessonId) => {
    return progress?.completedLessons?.includes(lessonId);
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="course-detail">
      <div className="course-header">
        <div className="course-info">
          <h1>{course?.title}</h1>
          <p>{course?.description}</p>
          <div className="course-meta">
            <span>📊 İlerleme: %{progress?.progress || 0}</span>
            <span>👨‍🏫 Eğitmen: {course?.teacher?.name}</span>
          </div>
        </div>
      </div>

      <div className="course-progress-bar">
        <div className="progress-fill" style={{ width: `${progress?.progress || 0}%` }}></div>
      </div>

      <div className="modules-container">
        {modules.map((module, moduleIndex) => (
          <div key={module._id} className="module-section">
            <div className="module-title">
              <h2>Modül {moduleIndex + 1}: {module.title}</h2>
              <p>{module.description}</p>
            </div>

            <div className="lessons-list">
              {module.lessons?.map((lesson, lessonIndex) => (
                <Link 
                  key={lesson._id}
                  to={`/student/lesson/${lesson._id}`}
                  className={`lesson-item ${isLessonCompleted(lesson._id) ? 'completed' : ''}`}
                >
                  <div className="lesson-info">
                    <span className="lesson-number">{lessonIndex + 1}</span>
                    <div className="lesson-details">
                      <h3>{lesson.title}</h3>
                      <p>{lesson.description}</p>
                    </div>
                  </div>
                  <div className="lesson-meta">
                    {lesson.isFree && <span className="badge-free">Ücretsiz</span>}
                    <span className="lesson-duration">{lesson.duration} dk</span>
                    {isLessonCompleted(lesson._id) && <span className="completed-badge">✓</span>}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CourseDetail;